module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "type": "text",
      "placeholder": "请填入报名人员姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号",
      "prop": "num",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(false) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否连考",
      "rules": []
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-color": "#409EFF",
      "inactive-color": "#ddd"
    },
    on: {
      "change": _vm.onLiankaoChange
    },
    model: {
      value: (_vm.formData.is_exam_continue),
      callback: function($$v) {
        _vm.$set(_vm.formData, "is_exam_continue", $$v)
      },
      expression: "formData.is_exam_continue"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报考星级",
      "prop": "grade"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.gradeSelectColumns), function(item) {
    return _c('el-radio', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("已付款禁止修改等级")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "添加证件照片(2寸)",
      "prop": "pic"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传2寸免冠照,此照片用于证书粘贴打印")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "衣服尺码",
      "prop": "csize",
      "rules": _vm.formData.grade.indexOf('红') != -1 ? [{
        required: true,
        message: '请输入尺码',
        trigger: 'blur'
      } ] : []
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入尺码"
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc mt10 cp",
    on: {
      "click": function($event) {
        _vm.cSizeShow = true
      }
    }
  }, [_vm._v("查看衣服尺码表")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "鞋  码",
      "prop": "footsize",
      "rules": _vm.formData.grade.indexOf('红') != -1 ? [{
        required: true,
        message: '请输入鞋码',
        trigger: 'blur'
      } ] : []
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入鞋码"
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc mt10 cp",
    on: {
      "click": function($event) {
        _vm.fSizeShow = true
      }
    }
  }, [_vm._v("查看鞋码表")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "购买考级服",
      "rules": []
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.formData.pay_status == 2,
      "active-text": "是",
      "inactive-text": "否",
      "active-value": 1,
      "inactive-value": 2,
      "active-color": "#409EFF",
      "inactive-color": "#ddd"
    },
    model: {
      value: (_vm.formData.buyc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "buyc", $$v)
      },
      expression: "formData.buyc"
    }
  }), _vm._v(" "), (_vm.formData.pay_status == 2) ? _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("已付款禁止修改")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "购买考级鞋",
      "rules": []
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.formData.pay_status == 2,
      "active-text": "是",
      "inactive-text": "否",
      "active-value": 1,
      "inactive-value": 2,
      "active-color": "#409EFF",
      "inactive-color": "#ddd"
    },
    model: {
      value: (_vm.formData.buys),
      callback: function($$v) {
        _vm.$set(_vm.formData, "buys", $$v)
      },
      expression: "formData.buys"
    }
  }), _vm._v(" "), (_vm.formData.pay_status == 2) ? _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("已付款禁止修改")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家长姓名",
      "prop": "famliy_name",
      "rules": [{
        required: true,
        message: '请输入家长姓名',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入家长姓名"
    },
    model: {
      value: (_vm.formData.famliy_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "famliy_name", $$v)
      },
      expression: "formData.famliy_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号码",
      "prop": "famliy_num",
      "rules": [{
        required: true,
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入正确的身份证号"
    },
    model: {
      value: (_vm.formData.famliy_num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "famliy_num", $$v)
      },
      expression: "formData.famliy_num"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "phone",
      "rules": [{
        required: true,
        validator: _vm.validator.phone,
        message: '请输入正确的手机号',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.cSizeShow,
      "title": "衣服尺码表"
    },
    on: {
      "update:visible": function($event) {
        _vm.cSizeShow = $event
      }
    }
  }, _vm._l((_vm.cSizePicList), function(pic, key) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": pic
      },
      on: {
        "click": function($event) {
          return _vm.picShow(key, _vm.cSizePicList)
        }
      }
    })
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.fSizeShow,
      "title": "鞋码表"
    },
    on: {
      "update:visible": function($event) {
        _vm.fSizeShow = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_vm._v("此鞋型偏小，建议选大一码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fSizePicList[0]
    },
    on: {
      "click": function($event) {
        return _vm.picShow(0, _vm.fSizePicList)
      }
    }
  })]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-314548f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyMemberDetail.vue
// module id = 1400
// module chunks = 0